export function useValueHelper() {
  const hasValue = (value) => {
    return value !== null && value !== undefined && value !== "";
  };

  return {
    hasValue,
  };
}
